import { takeEvery } from 'redux-saga/effects';

import * as actions from 'modules/medias/actions';
import * as actionTypes from 'modules/medias/actionTypes';

/** @type {Record<string, import("modules/app/types").SimpleRequestConfig>} */
const simpleRequests = {
  [actionTypes.DELETE_MEDIA]: {
    effect: takeEvery,
    callbacks: {
      success: (_, meta, { payload: { mediaId } }) => actions.deleteMediaSuccess(mediaId, meta),
    },
    notifications: {
      success: { id: 'page.fiche.notification.delete_media.success', defaultMessage: 'Media deleted' },
      failure: { id: 'page.fiche.notification.delete_media.failure', defaultMessage: "Can't delete the media" },
    }
  },
  [actionTypes.PERSIST_ITEMS_TO_ENTITY]: {
    notifications: {
      success: { id: 'page.fiche.notification.upload_file.success', defaultMessage: 'File uploaded' },
    }
  },
  [actionTypes.PATCH_MEDIA]: {},
  [actionTypes.GENERATE_ZIP]: {
    notifications: {
      success: undefined, // No success notification, handled by the callback
      failure: { id: 'page.fiche.notification.generate_zip.failure', defaultMessage: "Can't generate the zip file" },
    },
    callbacks: {
      success: (payload, meta) => actions.generateZipSuccess(payload, meta)
    }
  }
};

export default simpleRequests;
